import { useState, useEffect } from "react";
import { Check, Stethoscope, Phone, FileText, CalendarClock } from "lucide-react";
import clsx from "clsx";


const steps = [
  { icon: <Stethoscope className="w-5 h-5" />, label: "Chọn phương thức" },
  { icon: <CalendarClock className="w-5 h-5" />, label: "Chọn lịch khám" },
  { icon: <FileText className="w-5 h-5" />, label: "Nhập thông tin khám" },
  // { icon: <Check className="w-5 h-5" />, label: "Security" },
];

export default function StepProgress({ currentStep }) {
  return (
    <div className="flex items-start w-full max-w-3xl mx-auto px-6 py-2 relative">
      {steps.map((step, index) => (
        <div key={index} className="relative flex-1 flex flex-col">
          <div className="relative flex justify-center items-center">
            {/* Line before */}
            {index >= 0 && index < steps.length - 1 && (
              <div className="absolute left-[50%] top-1/2 w-full h-1 -translate-y-1/2 bg-gray-300 overflow-hidden">
                <div
                  className={clsx(
                    "h-full bg-green-500 origin-left transform-gpu will-change-transform transition-transform duration-500",
                    index < currentStep ? "scale-x-100" : "scale-x-0"
                  )}
                />
              </div>
            )}

            {/* Step Circle */}
            <div
              className={clsx(
                "z-10 md:w-10 md:h-10 h-9 w-9 flex items-center justify-center rounded-full border-2 transition-colors duration-300",
                index < currentStep
                  ? "bg-green-500 border-green-500 text-white"
                  : index === currentStep
                    ? "bg-white border-green-500 text-green-500"
                    : "bg-gray-100 border-gray-300 text-gray-400"
              )}
            >
              {index < currentStep ? <Check className="w-5 h-5" /> : step.icon}
            </div>
          </div>
          {/* <div className={clsx("text-center", 
            index === currentStep ? "text-green-600 font-medium" : ""
          )}>
            {step.label}
          </div> */}
        </div>
      ))}
    </div>
  );
}
